export const formatMoney = (value) => {
  const [integer, decimal] = Number(value).toFixed(2).split('.');
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return `CHF ${formattedInteger}.${decimal}`;
};
